import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import LoadingPage from "../../Components/layouts/loading";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";

import { BsPatchPlus } from "react-icons/bs";
import { FcDataConfiguration } from "react-icons/fc";
import MaterialPlanningTable from "./Material Planning/material_planning_table";
import CustomInput from "../../CustomComponent/custom_input";
import { MaterialForBaySpanSchema } from "../../Schemas/Material Planning/material_planning.schema";
import { Formik, Form } from "formik";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { useNavigate } from "react-router";
import CustomSelect from "../../CustomComponent/custom_select";
const baySpanValue = {
  bay: "",
  span: "",
  systemType: "",
};
const MaterialPlanning = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    bay: "",
    span: "",
    area: "",
    systemType: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  let userData = useSelector((store) => store.login.user);

  useEffect(() => {
    setLoading(true);
    const url = getFilteredURL(
      "/newMaterialModel/getMaterialModel/",
      page,
      filters
    );

    performRequest("GET", url)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.materialModelDataCount / 50));
        } else {
          Toast("error", "Error while getting Tasks!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page, userData.Role, userData.userName]);

  const handelSubmit = (values) => {
    performRequest("POST", "/newMaterialModel/createMaterialPlanning/", values)
      // performRequest(

      //   "GET",
      //   `/materialModel/getMaterialModel?bay=${values.bay}&span=${values.span}`
      // )
      .then((res) => {
        if (res.status === 201) {
          document.getElementById("modal-close").click();
          navigate(`/material-planning/edit/${res.data?.id}`);
        } else if (res.status === 200 && res.data?.dataId) {
          document.getElementById("modal-close").click();
          Toast("Error", res.data?.message);
          navigate(`/material-planning/${res.data?.dataId}`);
        } else {
          document.getElementById("modal-close").click();
          Toast(
            "Error",
            `Error while getting data for bay:${values.bay} & span:${values.span}`
          );
        }
      })
      .catch((err) => {
        document.getElementById("modal-close").click();
        CustomErrorResponse(err);
      });
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcDataConfiguration className="fs-2  me-1" /> Material
                  Planning
                </h2>
                <h4 className="text-muted">
                  Plan required material & to be produced.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
                    userData?.Role === process.env.REACT_APP_ROLE_PURCHASE ||
                    userData?.Role === process.env.REACT_APP_ROLE_ACCOUNTS) && (
                    // <a href={"/material-planning/new"}>
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#modal-small"
                      className="btn btn-primary d-none d-sm-block "
                    >
                      <BsPatchPlus className="me-2 fs-2" /> ADD NEW MATERIAL PLAN
                    </button>
                    // </a>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Bay Size:"
                              value={filters.bay}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  bay: e.target.value,
                                })
                              }
                              type="text"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Span Size:"
                              value={filters.span}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  span: e.target.value,
                                })
                              }
                              type="text"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Area:"
                              value={filters.area}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  area: e.target.value,
                                })
                              }
                              type="text"
                            ></DynamicFilterInput>
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="System:"
                              value={filters.systemType}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  systemType: e.target.value,
                                })
                              }
                              type="text"
                            >
                              <option value="">select system type...</option>
                              <option value="Open Ventilated Polyhouse F Bracket (6.5 meters)">
                                Open Ventilated Polyhouse F Bracket (6.5 meters)
                              </option>
                              <option value="Open Ventilated Polyhouse L Bracket (6.5 meters)">
                                Open Ventilated Polyhouse L Bracket (6.5 meters)
                              </option>
                              <option value="Shade Net House Tunnel (5 meters)">
                                Shade Net House Tunnel (5 meters)
                              </option>
                              <option value="Shade Net House Tunnel (4 meters)">
                                Shade Net House Tunnel (4 meters)
                              </option>
                              <option value="Shade Net House Flat (3 meters)">
                                Shade Net House Flat (3 meters)
                              </option>
                              <option value="Shade Net House Flat (4 meters)">
                                Shade Net House Flat (4 meters)
                              </option>
                              {/* <option value="Climate Control Polyhouse-10X4">
                                Climate Control Polyhouse-10X4
                              </option> */}
                              <option value="Climate Control Polyhouse-8X4">
                                Climate Control Polyhouse-8X4
                              </option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      status: "",
                                      assignTo: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Bay Size:"
                            value={filters.bay}
                            placeholder="Enter span size ex: 24"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                bay: e.target.value,
                              })
                            }
                            type="text"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Span Size:"
                            value={filters.span}
                            placeholder="Enter span size ex: 20"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                span: e.target.value,
                              })
                            }
                            type="text"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Area:"
                            value={filters.area}
                            placeholder="Enter area ex: 480"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                area: e.target.value,
                              })
                            }
                            type="text"
                          ></DynamicFilterInput>
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="System:"
                            value={filters.systemType}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                systemType: e.target.value,
                              })
                            }
                            type="text"
                          >
                            <option value="">select system type...</option>
                            <option value="Open Ventilated Polyhouse F Bracket (6.5 meters)">
                              Open Ventilated Polyhouse F Bracket (6.5 meters)
                            </option>
                            <option value="Open Ventilated Polyhouse L Bracket (6.5 meters)">
                              Open Ventilated Polyhouse L Bracket (6.5 meters)
                            </option>
                            <option value="Shade Net House Tunnel (5 meters)">
                              Shade Net House Tunnel (5 meters)
                            </option>
                            <option value="Shade Net House Tunnel (4 meters)">
                              Shade Net House Tunnel (4 meters)
                            </option>
                            <option value="Shade Net House Flat (3 meters)">
                              Shade Net House Flat (3 meters)
                            </option>
                            <option value="Shade Net House Flat (4 meters)">
                              Shade Net House Flat (4 meters)
                            </option>
                            {/* <option value="Climate Control Polyhouse-10X4">
                              Climate Control Polyhouse-10X4
                            </option> */}
                            <option value="Climate Control Polyhouse-8X4">
                              Climate Control Polyhouse-8X4
                            </option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    status: "",
                                    assignTo: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <MaterialPlanningTable
                    data={data?.materialModelData}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}
                {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
                  userData?.Role === process.env.REACT_APP_ROLE_PURCHASE ||
                  userData?.Role === process.env.REACT_APP_ROLE_ACCOUNTS) && (
                  <div className="btn-list justify-content-center">
                    {/* <a href={"/material-planning/new"}> */}
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#modal-small"
                      className="btn btn-primary d-lg-none d-md-none mt-3 mb-3"
                    >
                      <BsPatchPlus className="me-2 fs-2" />ADD NEW MATERIAL PLAN
                    </button>
                    {/* </a> */}
                  </div>
                )}

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.materialModelData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-small"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <Formik
                initialValues={baySpanValue}
                validationSchema={MaterialForBaySpanSchema}
                onSubmit={handelSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="modal-body">
                      <div className="modal-title">
                        Add bay and span before procced...
                      </div>
                      <div></div>
                      <div className="mb-3  mx-2">
                        <label className=" form-label col-3 required">
                          Bay:
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="bay" type="text" />
                          {props.touched.bay && props.errors.bay && (
                            <p className="text-danger">{props.errors.bay}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 mx-2">
                        <label className=" form-label col-3 required">
                          Span:
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="span" type="text" />
                          {props.touched.span && props.errors.span && (
                            <p className="text-danger">{props.errors.span}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 mx-2">
                        <label className=" form-label col-3 required">
                          System Type :
                        </label>
                        <div className="w-100 col">
                          <CustomSelect name="systemType" type="text">
                            <option value="">select system type...</option>
                            <option value="Open Ventilated Polyhouse F Bracket (6.5 meters)">
                              Open Ventilated Polyhouse F Bracket (6.5 meters)
                            </option>
                            <option value="Open Ventilated Polyhouse L Bracket (6.5 meters)">
                              Open Ventilated Polyhouse L Bracket (6.5 meters)
                            </option>
                            <option value="Shade Net House Tunnel (5 meters)">
                              Shade Net House Tunnel (5 meters)
                            </option>
                            <option value="Shade Net House Tunnel (4 meters)">
                              Shade Net House Tunnel (4 meters)
                            </option>
                            <option value="Shade Net House Flat (3 meters)">
                              Shade Net House Flat (3 meters)
                            </option>
                            <option value="Shade Net House Flat (4 meters)">
                              Shade Net House Flat (4 meters)
                            </option>
                            {/* <option value="Climate Control Polyhouse-10X4">
                              Climate Control Polyhouse-10X4
                            </option> */}
                            <option value="Climate Control Polyhouse-8X4">
                              Climate Control Polyhouse-8X4
                            </option>
                          </CustomSelect>
                          {props.touched.systemType &&
                            props.errors.systemType && (
                              <p className="text-danger">
                                {props.errors.systemType}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary me-auto"
                        data-bs-dismiss="modal"
                        id="modal-close"
                      >
                        Cancel
                      </button>
                      <FormSubmitButton buttonText={"Add Material plan"} />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default MaterialPlanning;
